export enum ScoreIntentClassStyleType {
    warning = 'warning',
    success = 'success',
    danger = 'danger',
    default = 'default',
    eq1 = 'eq1',
    eq2 = 'eq2',
    eq3 = 'eq3',
    eq4 = 'eq4',
    eq5 = 'eq5',
}
